// src/services/notification.ts
import api from "../lib/api";

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  isRead: boolean;
  metadata?: any;
  createdAt: string;
  updatedAt: string;
}

/**
 * Get all notifications for the current user
 */
export async function getMyNotifications(unreadOnly: boolean = false): Promise<Notification[]> {
  const params = new URLSearchParams();
  if (unreadOnly) params.append('unreadOnly', 'true');

  const { data } = await api.get(`/api/notifications?${params.toString()}`);
  return data.data.notifications;
}

/**
 * Get unread notification count
 */
export async function getUnreadCount(): Promise<number> {
  const { data } = await api.get('/api/notifications/unread-count');
  return data.data.count;
}

/**
 * Mark notification as read
 */
export async function markAsRead(notificationId: string): Promise<Notification> {
  const { data } = await api.put(`/api/notifications/${notificationId}/read`);
  return data.data.notification;
}

/**
 * Mark all notifications as read
 */
export async function markAllAsRead(): Promise<void> {
  await api.put('/api/notifications/mark-all-read');
}

/**
 * Delete a notification
 */
export async function deleteNotification(notificationId: string): Promise<void> {
  await api.delete(`/api/notifications/${notificationId}`);
}
